module.exports = __webpack_public_path__ + "static/media/benjamin_avatar.11bdc7ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/benjamin_avatar.jpg
// module id = 1001
// module chunks = 4